import {
  formatReplacementDemandNumber,
  formatReplacementDemandUnits,
} from '../../../lib/replacementDemandShiftHelpers';

export function ReplacementDemandShiftSummaryBar({ summary }) {
  if (!summary) return null;

  const cards = [
    { label: 'Shift rules in scope', value: formatReplacementDemandNumber(summary.ruleCount) },
    { label: 'Active shifts', value: formatReplacementDemandNumber(summary.activeCount) },
    { label: 'Original forecast units', value: formatReplacementDemandUnits(summary.originalUnits) },
    { label: 'Shifted units', value: formatReplacementDemandUnits(summary.shiftedUnits) },
    { label: 'Exceptions', value: formatReplacementDemandNumber(summary.exceptionCount) },
  ];

  return (
    <div className="mt-4 grid gap-2 md:grid-cols-2 xl:grid-cols-5">
      {cards.map(card => (
        <div key={card.label} className="rounded-md border border-gray-200 bg-white px-3 py-2">
          <p className="text-[11px] uppercase tracking-[0.12em] text-gray-500">{card.label}</p>
          <p className="mt-1 text-lg font-semibold text-gray-900">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
